import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { useRecoilValue } from 'recoil';
import { getProductFormattedNumber } from '../../../helpers/CurrencyUtils';
import ClientSideConfigSelector from '../../../../recoil/cashout/ClientSideConfigSelector';
import { capitalize } from '../../../helpers/SubscriptionsUtil';

export default function ConvertSubmission({ selectedPackage, handleSubmit, handleClose }) {
  const { t } = useTranslation(null, { useSuspense: false });
  const config = useRecoilValue(ClientSideConfigSelector);
  const {
    live: {
      claimReward: {
        appCurrency,
      } = {},
    },
  } = config;

  return (
    <div
      id="convert-confirmation"
      className="phoenix-simple-dialog-view modal member-diamonds-cash-confirm fade-in show"
      aria-hidden="false"
    >
      <div className="modal-backdrop fade in" />
      <div className="modal-dialog">
        <div className="modal-content modal-content-sm">
          <div className="modal-header">
            {/* eslint-disable-next-line jsx-a11y/anchor-has-content,jsx-a11y/anchor-is-valid */}
            <a
              className="close phoenix-icon phoenix-icon-cross hidden-xs hidden-sm"
              aria-hidden="true"
              onClick={handleClose}
            />
            <h4>{t('convert_are_you_sure_')}</h4>
          </div>
          <div className="modal-body">
            <p id="convert-confirmation-text">
              {
                t(
                  'convert_this_will_remove___diamonds___diamonds_from_your_account_and_add___credits_____appcurrency___',
                  {
                    diamonds: getProductFormattedNumber(selectedPackage.purchase.price),
                    credits: getProductFormattedNumber(selectedPackage.exchange.price),
                    appCurrency: capitalize(t(appCurrency?.toLowerCase())),
                  },
                )
              }
            </p>
          </div>
          <div className="modal-footer">
            <form className="form-horizontal">
              <div className="form-group">
                <div className="col-xs-12">
                  <button
                    type="button"
                    className="btn btn-undesired btn-half"
                    data-dismiss="modal"
                    onClick={handleClose}
                    aria-hidden="true"
                  >
                    {t('convert_cancel')}
                  </button>
                  <button
                    id="submit-convert"
                    type="submit"
                    onClick={handleSubmit}
                    className="btn btn-primary btn-half"
                    aria-hidden="true"
                  >
                    {t('convert_ok')}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
ConvertSubmission.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  selectedPackage: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
};
